<!-- LISTA DE APORTACIONES -->
<template>
  <b-col cols="12">
    <b-overlay
      :show="isBusyTable"
      rounded="sm"
    >
      <b-card
        v-show="!errorContent.table"
        no-body
        class="mb-0"
      >
        <transition name="fade-bottom">
          <section>
            <!-- Table Top -->
            <filtro-planes
              :plan-filter.sync="configRequest.wsParams.plan"
              :status-filter.sync="configRequest.status"
              :in-plan="plan"
              :search-query.sync="searchQuery"
              :per-page.sync="perPage"
              :per-page-options="perPageOptions"
            />
            <!-- table -->
            <b-table
              ref="refDataListTable"
              class="position-relative"
              :items="fetchData"
              responsive
              :fields="tblColumFull"
              :sort-by.sync="sortBy"
              show-empty
              empty-text="Sin aportaciones registradas"
              :sort-desc.sync="isSortDirDesc"
            >
              <!-- Column: Actions -->
              <template #cell(actions)="data">
                <div class="text-nowrap">
                  <!-- ver -->
                  <b-link
                    v-if="isObject(userRol) && !isEmptyObject(userRol) && isLista"
                    class="font-weight-bold text-secondary"
                    @click="LinkReady(data.item.orden)"
                  >
                    <feather-icon
                      :id="`trans-row-${data.item.id}-detalle`"
                      icon="CoffeeIcon"
                      class="text-success cursor-pointer mr-1"
                      size="16"
                    />
                  </b-link>
                  <!-- autorizar -->
                  <feather-icon
                    v-if="isObject(userRol) && !isEmptyObject(userRol)"
                    v-show="userRol.id != 1 && data.item.status == 'ACT'"
                    :id="`trans-row-${data.item.id}-auth-icon`"
                    icon="CheckCircleIcon"
                    class="mr-1 cursor-pointer"
                    size="16"
                    @click="authTransaccion(data.item)"
                  />
                  <!-- rechazar -->
                  <feather-icon
                    v-if="isObject(userRol) && !isEmptyObject(userRol)"
                    v-show="userRol.id != 1 && data.item.status == 'ACT'"
                    :id="`trans-row-${data.item.id}-reject-icon`"
                    icon="Trash2Icon"
                    class="mr-1 cursor-pointer"
                    size="16"
                    @click="mdlCancelar(data.item)"
                  />
                  <!-- descarga file -->
                  <a @click="downloadFile(data.item.rutaDoc + data.item.extBase)">
                    <feather-icon
                      :id="`trans-row-${data.item.id}-down-icon`"
                      icon="PaperclipIcon"
                      class="cursor-pointer"
                      size="16"
                    />
                  </a>
                </div>
              </template>
              <!-- detalles tab -->
              <template #cell(show_details)="row">
                <b-form-checkbox
                  v-model="row.detailsShowing"
                  plain
                  class="vs-checkbox-con"
                  @change="row.toggleDetails"
                >
                  <span class="vs-checkbox">
                    <span class="vs-checkbox--check">
                      <i class="vs-icon feather icon-check" />
                    </span>
                  </span>
                  <span class="vs-label">{{ row.detailsShowing ? 'Ocultar' : 'Mostrar' }}</span>
                </b-form-checkbox>
              </template>
              <!-- detalle de row -->
              <template #row-details="row">
                <b-card>
                  <b-row class="mb-2">
                    <b-col
                      md="4"
                      class="mb-1"
                    >
                      <strong>Aportacion : </strong>{{ row.item.monto }}
                    </b-col>
                    <b-col
                      md="4"
                      class="mb-1"
                    >
                      <strong>Forma_Pago: </strong>{{ row.item.forma_pago }}
                    </b-col>
                    <b-col
                      md="4"
                      class="mb-1"
                    >
                      <strong>Metodo_Pago: </strong>{{ row.item.metodoPago }}
                    </b-col>
                    <!-- next level -->
                    <b-col
                      md="4"
                      class="mb-1"
                    >
                      <strong>Aprob_Admin : </strong>{{ (row.item.aprobadoAdmin == 1) ? 'SI': 'Pendiente' }}
                    </b-col>
                    <b-col
                      md="4"
                      class="mb-1"
                    >
                      <strong>Fecha_Admin : </strong>{{ row.item.fechaAprobAdmin }}
                    </b-col>
                    <b-col
                      md="4"
                      class="mb-1"
                    >
                      <strong>Fecha_Contab : </strong>{{ row.item.fechAprobContab }}
                    </b-col>
                    <b-col
                      md="4"
                      class="mb-1"
                    >
                      <strong>Comentarios : </strong><br>{{ row.item.comentarios }}
                    </b-col>
                    <b-col
                      md="4"
                      class="mb-1"
                    >
                      <strong>Observaciones : </strong><br>{{ row.item.observaciones }}
                    </b-col>
                    <b-col
                      md="4"
                      class="mb-1"
                    >
                      <strong>Obser_Factura : </strong><br>{{ row.item.fac_observaciones }}
                    </b-col>
                  </b-row>
                  <b-button
                    size="sm"
                    variant="outline-secondary"
                    @click="row.toggleDetails"
                  >
                    Menos Detalles
                  </b-button>
                </b-card>
              </template>
              <!-- status-->
              <template #cell(status)="row">
                <b-badge :variant="frmstatus(row.item.status).color">
                  {{ frmstatus(row.item.status).text }}
                </b-badge>
              </template>
              <!-- fecha pago -->
              <template #cell(fecha_pago)="row">
                <span class="text-nowrap">
                  {{ row.item.fecha_pago }}
                </span>
              </template>
              <!-- ver factura -->
              <template #cell(factura)="row">
                <span class="text-nowrap">
                  <b-badge
                    :class="(row.item.factura) ? 'cursor-pointer' : '' "
                    :variant="(row.item.factura) ? 'light-primary' : '' "
                    @click="PrintFactura(row.item)"
                  >{{ (row.item.factura) ? 'Ver Factura' : 'N/A' }}</b-badge>
                </span>
              </template>

            </b-table>
            <!-- footer / table -->
            <div class="mx-2 mb-2">
              <b-row>
                <!-- Leyenda de cuantos elementos se muestran -->
                <b-col
                  cols="12"
                  sm="6"
                  class="d-flex align-items-center justify-content-center justify-content-sm-start"
                >
                  <span class="text-muted">Mostrando {{ dataMeta.from }} a {{ dataMeta.to }} de {{ dataMeta.of }} registros</span>
                </b-col>
                <!-- Pagination -->
                <b-col
                  cols="12"
                  sm="6"
                  class="d-flex align-items-center justify-content-center justify-content-sm-end"
                >

                  <b-pagination
                    v-model="currentPage"
                    :total-rows="totalItems"
                    :per-page="perPage"
                    first-number
                    last-number
                    class="mb-0 mt-1 mt-sm-0"
                    prev-class="prev-item"
                    next-class="next-item"
                  >
                    <template #prev-text>
                      <feather-icon
                        icon="ChevronLeftIcon"
                        size="18"
                      />
                    </template>
                    <template #next-text>
                      <feather-icon
                        icon="ChevronRightIcon"
                        size="18"
                      />
                    </template>
                  </b-pagination>
                </b-col>
              </b-row>
            </div>
          </section>
        </transition>
      </b-card>
    </b-overlay>
    <!-- detalle factura -->
    <b-modal
      :id="configMood.id"
      v-model="modalShow"
      size="lg"
      :title="configMood.title"
      ok-only
      no-body
      @hide="modalShow = false"
    >
      <b-col
        lg="12"
        md="12"
      >
        <cmp-factura
          :factura="infofact"
          :persona="infoPersona"
          :id-orden="idOrden"
          :solicitud="setTran"
        />
      </b-col>
    </b-modal>
    <!-- notificar a contabilidad -->
    <b-modal
      v-model="modContabilidad"
      size="lg"
      title="¿Notificar a Contabilidad?"
      no-body
      @hide="modContabilidad = false"
    >
      <b-col
        lg="12"
        md="12"
      >
        <b-alert
          class="mb-1"
          show
          variant="success"
        >
          <div class="alert-body">
            <span>No. <b>#{{ setItem.id }}</b>, Aportación: <b>${{ setItem.monto }}</b>, Registrado: <b>${{ setItem.fecha_pago }}</b>.</span>
          </div>
        </b-alert>
        <b-input-group prepend="Observaciones">
          <b-form-textarea
            id="txtobservacionesNot"
            v-model="txtobservaciones"
            placeholder="Ingrese alguna observacion si lo cree necesario."
            rows="3"
            no-resize
          />
        </b-input-group>
        <div class="d-block mt-2 text-center">
          <b-button
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            variant="outline-primary"
            :disabled="(setItem.status != 'ACT') ? true : false"
            @click="procederAuth()"
          >
            <feather-icon
              :icon="(flagproceder) ? 'ClockIcon' : 'ArrowRightIcon'"
              class="mr-50"
            />
            <b-spinner
              v-show="flagproceder"
              small
              type="grow"
            />
            {{ (flagproceder) ? 'Trabajando...': 'Proceder a notificar' }}
          </b-button>
        </div>
      </b-col>
      <template #modal-footer>
        <div class="w-100">
          <b-badge variant="light-warning">
            {{ (setItem.factura !== null) ? 'Si la transacción cuenta con factura se marcara la fecha y las observaciones.' : 'Esta transaccion no requiere factura' }}
          </b-badge>
          <b-button
            variant="secondary"
            size="sm"
            class="float-right"
            @click="modContabilidad=false"
          >
            Cancelar
          </b-button>
        </div>
      </template>
    </b-modal>
    <!-- Cancelar transaccion -->
    <b-modal
      v-model="flagreject"
      size="lg"
      title="¿Cancelación administrativa de transacción?"
      no-body
      hide-footer
      @hide="flagreject = false"
    >
      <accion-cancelacion
        v-if="!isEmptyObject(currentTran)"
        :transaccion="currentTran.id"
        :open-modal.sync="flagreject"
        @reload-data="refetchData(true)"
      />
    </b-modal>
  </b-col>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BButton,
  BTable,
  BBadge,
  BPagination,
  BFormTextarea,
  BAlert,
  BOverlay,
  BInputGroup,
  BSpinner,
  BLink,
  BFormCheckbox,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import {
  frmstatus, avatarText,
} from '@core/utils/filter'
import {
  useRouter, formhttp, shipcode, isObject, isEmptyObject,
} from '@core/utils/utils'
import hostname from '@core/utils/http/config-hostname'
// import vSelect from 'vue-select'
import {
  ref, onMounted, watch, getCurrentInstance,
} from '@vue/composition-api'
import store from '@/store'
import { rolesActions } from '@core/mixins/account-data/roles'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { useFillDataTable } from '@core/components/data-table/useFillDataTable'
import { configTableAportaciones } from './useComprasList'
import filtroPlanes from '../components/FiltroPlanes.vue'
import CmpFactura from '../components/DetailFact.vue'
import accionCancelacion from '../tareas/cancelar-transaccion.vue'
/**
 * * componente que funciona para servicios escolares y alumno
 */
export default {
  name: 'ListaTransacciones',
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    BTable,
    BBadge,
    BPagination,
    // vSelect,
    CmpFactura,
    BFormTextarea,
    BAlert,
    BOverlay,
    BInputGroup,
    BSpinner,
    BLink,
    filtroPlanes,
    BFormCheckbox,
    accionCancelacion,
  },
  directives: {
    Ripple,
  },
  mixins: [rolesActions],
  props: {
    frompublic: {
      type: Boolean,
      default: () => false,
    },
    isLista: {
      type: Boolean,
      default: () => false,
    },
    identiorden: {
      type: [Number],
      default: 0,
    },
    plan: {
      type: [Number, null],
      default: 0,
    },
  },
  data() {
    return {
      itemsaa: [],
      setItem: {},
      txtobservaciones: '',
      objfactura: {},
    }
  },
  methods: {
    authTransaccion(obj) {
      this.setItem = obj
      this.modContabilidad = true
    },
    procederAuth() {
      // call api for upd revisara de acuerdo al rol que lo use
      this.objfactura = {
        action: 24, Idtran: this.setItem.id, factura: this.setItem.factura, observaciones: this.txtobservaciones, urol: this.userRol.id,
      }
      this.transReady(this.objfactura)
    },
  },
  setup(props) {
    const { route } = useRouter()
    const errorContent = ref({ filters: false, table: false })
    const idOrden = ref((route.value.params.orden) ? parseInt(window.atob(route.value.params.orden), 10) : 0)
    const vm = getCurrentInstance().proxy
    // cuando seleccionan un item de la lista
    const currentTran = ref({})

    if (props.identiorden !== 0) {
      idOrden.value = props.identiorden
    }
    const toast = useToast()
    const configMood = ref({ id: 'info-modal', title: '', content: '' })
    const modalShow = ref(false)
    const modContabilidad = ref(false)
    const flagproceder = ref(false)
    const flagreject = ref(false)
    const infofact = ref({})
    const infoPersona = ref({})
    const setTran = ref({})
    const { tblColumFull, configRequest } = configTableAportaciones()
    if (props.isLista === false) {
      // tblColumFull.splice(1, 1)
    }
    const {
      //* Fetching data
      fetchData, refetchData, refDataListTable, dataAux,
      //* Pagination
      dataMeta,
      //* Table dynamic params
      dynamicParamRequest,
      //* Basic filters & pagination
      perPage, totalItems, currentPage, perPageOptions, searchQuery, sortBy, isSortDirDesc,
      //* Loader
      isBusyTable,
      //* Error
      errorRequest,
    } = useFillDataTable()
    // define el ordenamiento de la tabla ASC / DESC
    isSortDirDesc.value = true

    //  load componente for cancelar
    const mdlCancelar = obj => {
      currentTran.value = obj
      flagreject.value = true
    }

    // const mtri = (route.value.params.mtr) ? route.value.params.mtr : null

    /**
     * * Marcar transaccion valida para ser revisada por contabilidad
     * @param datos es un config [action: 24, Idtran: this.setItem.id, factura: this.setItem.factura, observaciones: this.txtobservaciones, urol: this.userRol.id]
     */
    const transReady = datos => {
      flagproceder.value = true
      store.dispatch('compras/postCompras', datos)
        .then(response => {
          const { icon, label } = formhttp(response.status)
          toast({
            component: ToastificationContent,
            props: {
              title: response.message,
              text: response.resultado,
              icon,
              variant: label,
            },
          },
          { timeout: 8000 })
          if (response.status === 200) refetchData(true); modContabilidad.value = false
          flagproceder.value = false
        }, error => {
          flagproceder.value = false
          toast({
            component: ToastificationContent,
            props: {
              title: 'Atención aqui',
              text: error,
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          },
          { timeout: 10000 })
        })
    }

    const PrintFactura = objTran => {
      if (objTran.factura !== null) {
        setTran.value = objTran
        const config = 'menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes,width=700,height=800'
        const routeData = `${hostname().host}/app/imprimir/factura/${setTran.value.factura}/${idOrden.value}/${setTran.value.id}/`
        window.open(routeData, 'Imprimir Factura', config)
      }
    }

    /**
     * * muestra el comprobante que subio, proviene de un servicio delivery
     * Lo muestra en una ventana nueva
     * @param file ruta del archivo fisico en el server
     * TODO PROVIENE DE UN SERVICIO EXTERNO [ delivery ]
     */
    const downloadFile = file => {
      window.open(`${process.env.VUE_APP_DELIVERY_DOWNLOAD + file}`, '_blank')
    }

    // preparar link for refresh
    const LinkReady = iden => {
      vm.$swal({
        html: 'Hola, usted saldra de la pantalla actual para ir a la solicitud',
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'No, mantenerme aqui.',
        confirmButtonText: 'Si, continuar',
        customClass: {
          confirmButton: 'btn btn-sm btn-primary',
          cancelButton: 'btn btn-sm btn-warning mr-1',
        },
        reverseButtons: true,
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          const routeData = `${hostname().host}/app/compras/${(store.state.cuenta.rolSelected.id !== 1) ? 'ordenes/preview' : 'preview'}/${shipcode(iden)}/`
          window.location.replace(routeData)
        }
      })
    }

    watch([() => configRequest.value.wsParams.plan, () => configRequest.value.status], ([plan, status]) => {
      if (plan != null && status == null) {
        refetchData(true) // call api
      } else if (status != null && plan != null) {
        refetchData(false)
      } else if (plan == null && status == null) {
        refetchData(true) // seteamos vacia la lista
      }
    }, { immediate: true })

    onMounted(
      () => {
        if (props.isLista === false) {
          configRequest.value.wsParams.orden = idOrden.value
        }
        // pre-cargar si tiene un plan en props
        if (props.plan != null) {
          configRequest.value.wsParams.plan = props.plan
        }
        dynamicParamRequest.value = configRequest.value
      },
    )

    watch(errorRequest, error => { if (error) errorContent.value.table = error })
    watch(configRequest.value, () => { refetchData(true) })

    return {
      fetchData,
      tblColumFull,
      perPage,
      currentPage,
      totalItems,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refDataListTable,
      refetchData,
      dataAux,
      isBusyTable,
      errorContent,
      configRequest,

      downloadFile,
      avatarText,
      // new tasks
      transReady,
      PrintFactura,
      shipcode,
      LinkReady,
      isObject,
      isEmptyObject,
      mdlCancelar,
      idOrden,
      frmstatus,
      configMood,
      // flags
      flagreject,
      flagproceder,
      modalShow,
      modContabilidad,
      // LoadFactura,
      // datos
      infofact,
      infoPersona,
      setTran,
      currentTran,
    }
  },
}
</script>

<style lang="scss" scoped>
  .per-page-selector {
    width: 90px;
  }

  .invoice-filter-select {
    min-width: 190px;

    ::v-deep .vs__selected-options {
      flex-wrap: nowrap;
    }

    ::v-deep .vs__selected {
      width: 100px;
    }
  }
</style>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
</style>
